import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {fetchJSON} from '../../../../../helpers/FetchUtils';
import {ACCOUNT_MEMBER_SELECT_QUERY} from './constants';
import {
    queryAccountMemberSelectFail,
    queryAccountMemberSelectSuccess
} from './actions';
import {layoutMainSignCheck} from "../../../layouts/main/actions";
import {catchError, showErrorToast} from "../../../../../util/ErrorCatchUtils";

//
function* queryAccountMemberSelect({payload: {params}}) {
    try {
        let {page, filter} = params;
        const response = yield call(fetchJSON,
            '/api/account/member/select/query',
            {body: JSON.stringify({page, filter})}
        );
        if (response.success) {
            const responseData = response.data;
            page.current = responseData.page.current;
            yield put(queryAccountMemberSelectSuccess({queryDatas: {...responseData}, params}));
        } else {
            yield put(layoutMainSignCheck(response));
            yield put(queryAccountMemberSelectFail(response));
        }
    } catch (error) {
        yield put(layoutMainSignCheck(showErrorToast(error)));
        yield put(queryAccountMemberSelectFail(catchError(error)));
    }
}

//
export function* queryAccountMemberSelectWatcher() {
    yield takeEvery(ACCOUNT_MEMBER_SELECT_QUERY, queryAccountMemberSelect);
}

//
function* AccountMemberSelectSaga() {
    yield all([
        fork(queryAccountMemberSelectWatcher)
    ]);
}

/**
 *
 */
export default AccountMemberSelectSaga;
